export default {
  changeFlag (state, value) {
    state.value = value
    try {
      localStorage.value = value
    } catch (error) {}
    localStorage.value = value
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js